import { Platform, Pressable, View } from "react-native";
import React, { memo } from "react";
import CustomComponent from "../../../../../components/CustomComponent";
import { Colors } from "../../../../../globalStyles/ColorConfig";
import GlobalStyles from "../../../../../globalStyles/globalStyles";
import dimensions from "../../../../../globalStyles/dimensions";
import ExperienceIcons from "../../../../../assets/Icons/ExperienceIcons";

const shadowStyle =
  Platform.OS === "ios"
    ? {
        shadowColor: Colors.black100,
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.3,
        shadowRadius: 4,
      }
    : Platform.OS === "android"
    ? {
        elevation: 2,
      }
    : {
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 0,
        },
        shadowOpacity: 0.1,
        shadowRadius: 10,
        elevation: 1,
      };

const IncludeComponent = ({ item, toggle }: { item: any; toggle: any }) => {
  const renderDescription = () => {
    const description = item.item.packagesDescription;
    if (description.length > 70) {
      return (
        <>
          <CustomComponent.TextView
            numberoflines={3}
            title={`${description}`}
            textStyle={[
              GlobalStyles.bodyText,
              {
                opacity: 0.4,
                fontSize: 14,

                letterSpacing: -0.4,
              },
            ]}
          />
          <View
            style={{
              width: Platform.OS === "web" ? 90 : dimensions.windowWidth / 4.5,
              marginTop: 5,
            }}
          >
            <CustomComponent.TextView
              title={"Read more"}
              textStyle={[
                GlobalStyles.bodyText,
                {
                  color: Colors.gold10,
                  borderBottomWidth: 1,
                  letterSpacing: -0.3,
                  borderBottomColor: Colors.gold10,
                  fontFamily: "InterMedium",
                },
              ]}
            />
          </View>
        </>
      );
    } else {
      return (
        <CustomComponent.TextView
          title={description}
          textStyle={GlobalStyles.bodyText}
        />
      );
    }
  };

  const includedPackagesName =
    item.item.includedPackagesName.length > 18
      ? `${item.item.includedPackagesName.slice(0, 18)}...`
      : item.item.includedPackagesName;

  return (
    <Pressable onPress={toggle}>
      <View
        style={{
          width: 240,
        minHeight : 200,
          paddingHorizontal:
            Platform.OS === "web" ? 20 : dimensions.paddingHorizontal,
          paddingVertical: dimensions.paddingVertical,
          gap: 4,
          borderRadius: 8,
          backgroundColor: Colors.white000,
          shadowColor: Colors.black100,
          ...shadowStyle,
        }}
      >
        {item?.item?.category === "Food" ? (
          <View style={{left: -4}}>
            <ExperienceIcons.Food />
          </View>
        ) : item?.item?.category === "Drink" ? (
          <View style={{left: -8}}>
            <ExperienceIcons.Drinks />
          </View>
        ) : item?.item?.category?.toString().includes("Massage") ? (
          <View style={{left: -4}}>
            <ExperienceIcons.Massage />
          </View>
        ) : (
          <View style={{left: -4}}>
          < ExperienceIcons.SparkFav />
          </View>
        )}

        <CustomComponent.TextView
          title={includedPackagesName}
          textStyle={[
            GlobalStyles.title2,
            {
              fontFamily: "InterSemiBold",
              letterSpacing: -0.3,
              color: Colors.black70,
            },
          ]}
        />
        {renderDescription()}
      </View>
    </Pressable>
  );
};

export default memo(IncludeComponent);
